export function getSnippetImageStyle(payload: CometOperatorApplication.SnippetCometMessageOpenApiModel, size?: number) {
    if (size) {
        let style = `max-width: 100% !important; aspect-ratio: ${payload.image_size[0]} / ${payload.image_size[1]} !important;`;
        if (payload.image_size[0] > payload.image_size[1]) {
            style += `width: ${Math.min(payload.image_size[0], size)}px !important;`
        } else {
            style += `max-height: ${Math.min(payload.image_size[1], size)}px !important;`
        }
        return style;
    }
    return null;
}